/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SitePagination
 */
export interface SitePagination {
  /**
   *
   * @type {number}
   * @memberof SitePagination
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof SitePagination
   */
  lastPage: number
  /**
   *
   * @type {number}
   * @memberof SitePagination
   */
  perPage: number
  /**
   *
   * @type {number}
   * @memberof SitePagination
   */
  totalRecords: number
}

/**
 * Check if a given object implements the SitePagination interface.
 */
export function instanceOfSitePagination(
  value: object
): value is SitePagination {
  if (!('page' in value) || value['page'] === undefined) return false
  if (!('lastPage' in value) || value['lastPage'] === undefined) return false
  if (!('perPage' in value) || value['perPage'] === undefined) return false
  if (!('totalRecords' in value) || value['totalRecords'] === undefined)
    return false
  return true
}

export function SitePaginationFromJSON(json: any): SitePagination {
  return SitePaginationFromJSONTyped(json, false)
}

export function SitePaginationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SitePagination {
  if (json == null) {
    return json
  }
  return {
    page: json['page'],
    lastPage: json['lastPage'],
    perPage: json['perPage'],
    totalRecords: json['totalRecords'],
  }
}

export function SitePaginationToJSON(value?: SitePagination | null): any {
  if (value == null) {
    return value
  }
  return {
    page: value['page'],
    lastPage: value['lastPage'],
    perPage: value['perPage'],
    totalRecords: value['totalRecords'],
  }
}
